import { defineStore } from '#imports';
import type { DialogTypes } from '../types';

export const useUserDialogStore = defineStore('UserDialog', {
	state: (): DialogTypes.State => ({
		dialog: {
			sign: false,
			password: false,
			recoveryPassword: false,
		},
	}),

	actions: {
		showSpecialUserDialog(specialDialog: DialogTypes.dialogUserKey) {
			Object.keys(this.dialog).forEach((key) => {
				// @ts-ignore
				this.dialog[key] = false;
			});

			this.dialog[specialDialog] = true;
		},

		closeUserDialog() {
			Object.keys(this.dialog).forEach((key) => {
				// @ts-ignore
				this.dialog[key] = false;
			});
		},
	},
});
